import Vue from 'vue'
import qs from 'qs'
let vue = new Vue()
const api = {
    action: {
        login: {}
    },
    /**
     * 获取密码加密公钥
     * @method getPublicKey
     * @param {String} userName
     * GET /brm/evo-oauth/v1.0/oauth/publicKey
     * Response:
     * @returns {promise} results
     */
    getPublicKey(param) {
        return new Promise((resolve, reject) => {
            vue.resetAjax({
                method: 'get',
                url: `evo-oauth/VERSION/oauth/public-key?username=${encodeURI(param)}`,
                isNoLock: true,
                isSNoTip: true,
                headers: {
                    Authorization: ''
                },
                onSuccess(rel) {
                    resolve(rel)
                },
                onError(rel) {
                    reject(rel)
                }
            })
        })
    },
    /**
     * 账号密码登录：refreshToken
     * @method login
     * @param {Object}
     * {
     *  'username': userName, 账号
     *  'refresh_token': refreshToken, 刷新token
        'password': password, 密码
        'grant_type':'password', 登录方式
        'client_id':'app_client',
        "client_secret":'app_client'
     * }
     * post /brm/evo-oauth/v1.0/oauth/token
     * Response:
     * @returns {promise} results
     */
    login(userName, password, publicKey) {
        let value = {
            username: userName,
            password: password,
            grant_type: 'password',
            client_id: 'app_client',
            client_secret: 'app_client',
            public_key: publicKey
        }
        return new Promise((resolve, reject) => {
            vue.resetAjax({
                method: 'post',
                url: '/evo-oauth/oauth/token',
                data: qs.stringify(value),
                isNoLock: true,
                isSNoTip: true,
                isENoTip: true,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    Authorization: ''
                },
                onSuccess(rel) {
                    resolve(rel)
                },
                onError(rel) {
                    reject(rel)
                }
            })
        })
    },
    commonApi(url, method, params, headers) {
        return new Promise((resolve, reject) => {
            const p = {
                method: method || 'get',
                url: url,
                isNoLock: true,
                isSNoTip: true,
                data: params,
                isENoTip: true,
                onSuccess(rel) {
                    resolve(rel.data)
                },
                onError(rel) {
                    reject(rel.data)
                }
            }
            if(headers) {
                p.headers = headers
            }
            vue.resetAjax(p)
        })
    },
    // getInviteInfo(param) {
    //     debugger
    //     return new Promise((resolve, reject) => {
    //         vue.resetAjax({
    //             method:'get',
    //             url: `https://10.81.12.96:8910/evo-visitor/VERSION/visitorInvite/query?visitorPhone=${param.phoneNum}`,
    //             isNoLock: true,
    //             isSNoTip: true,
    //             data: params,
    //             urlType:2,
    //             onSuccess(rel) {
    //                 resolve(rel.data)
    //             },
    //             onError(rel) {
    //                 reject(rel.data)
    //             }
    //         })
    //     })
    // },
    /**
     * @method getBaseConfig() 获取访客基础信息
     */
    getBaseConfig() {
        return this.commonApi(`evo-visitor/VERSION/card/visitor/config/visit/config?systime=${new Date().getTime()}`, 'get', {})
    },
    // /**
    //  * 获取访客类型
    //  * **/
    getVisitorType(type, visitorMode) {
        // return this.commonApi(`evo-visitor/VERSION/visitor-type/page?pageSize=20&pageNum=1&searchKey=&systime=${new Date().getTime()}`, 'get', {})
        // return this.commonApi(`evo-visitor/VERSION/visitor-type/visitor-attribution/1?systime=${new Date().getTime()}`, 'get', {})
        // visitorMode=1学生，2教职工
        return this.commonApi(`evo-visitor/VERSION/visitor-type/visitor-attribution/${type}?visitorMode=${visitorMode || ''}&systime=${new Date().getTime()}`, 'get', {})

    },
    getVistorAreaByVisitor(param) {
      return this.commonApi(`evo-visitor/VERSION/visitor-type/page?systime=${new Date().getTime()}`, 'post', param)
  },
    // 获取民族信息
    getNationInfo(param) {
        return this.commonApi(`evo-visitor/VERSION/custom/mz/getAllMz?pageSize=${param.pageSize}&pageNum=${param.pageNum}&userId=${param.userId}`, 'get', {})
    },

    getInviteInfo(param) {
        // return this.commonApi(`evo-visitor/VERSION/visitor-type/page?pageSize=20&pageNum=1&searchKey=&systime=${new Date().getTime()}`, 'get', {})
        return this.commonApi(`evo-visitor/VERSION/visitorInvite/query?visitorPhone=${param.phoneNum}`, 'get', {})

    },
    getSchoolKnow() {
        // return this.commonApi(`evo-visitor/VERSION/visitor-type/page?pageSize=20&pageNum=1&searchKey=&systime=${new Date().getTime()}`, 'get', {})
        return this.commonApi(`evo-visitor/VERSION/visitor-notification`, 'get', {})

    },
    /**
     * @param {*} param
     * @returns
     */
    getVistorArea(param) {
        return this.commonApi(`evo-visitor/VERSION/area/page?systime=${new Date().getTime()}`, 'post', param)
    },

    /**
     * @param {*} param
     * @returns
     */
     getNextPerson(id) {
        return this.commonApi(`evo-visitor/1.0.0/custom/visitor/getNextReviewInfo?visitorId=${id}`, 'get')
    },
    getNextPerson1(param) {
        return this.commonApi(`evo-visitor/VERSION/custom/visitor/getNextReviewInfoByInterviewee`, 'post', param)
    },
    /**
     * 根据手机号码查询被访人员姓名
     * @param {string} param - 手机号
     * @param {string} visitorstampKey - 时间戳（可选）
     * **/
    getIntervieweeNameByPhone(param, visitorstampKey) {
        const timestamp = visitorstampKey || new Date().getTime() + '000'
        return this.commonApi(
            `evo-visitor/VERSION/card/visitor/getPersonByPhone/${param}?systime=${new Date().getTime()}`,
            'post',
            {},
            {
                'Visitorstamp-Key': timestamp
            }
        )
    },
    /**
     * 根据工号查询被访人员姓名
     * @param {string} param - 工号
     * @param {string} visitorMode - 访问模式
     * @param {string} visitorstampKey - 时间戳（可选）
     * **/
    getIntervieweeNameByCode(param, visitorMode, visitorstampKey) {
        const timestamp = visitorstampKey || new Date().getTime() + '000'
        return this.commonApi(
            `evo-visitor/VERSION/card/visitor/getPersonInfo/${param}?visitorMode=${visitorMode || ''}`,
            'get',
            {},
            {
                'Visitorstamp-Key': timestamp
            }
        )
    },
    /**
     * 提交访客预约登记信息
     * **/
    addVisitorInfo(params) {
        return this.commonApi(`evo-visitor/VERSION/card/visitor/appointment?systime=${new Date().getTime()}`, 'post', params)
    },
    /**
     * 提交访客邀约信息
     * **/
    addVisitor(params) {
        return this.commonApi(`evo-visitor/VERSION/visitorInvite`, 'post', params)
    },

    /**
     * 审核登录
     */
    auditLogin(params) {
        return this.commonApi(`evo-visitor/VERSION/card/person/login?systime=${new Date().getTime()}`, 'post', params)
    },
    /**
     * 修改密码
     */
    changePassword(params) {
        return this.commonApi(`evo-visitor/VERSION/card/person/modifyPassword?systime=${new Date().getTime()}`, 'post', params)
    },
    /**
     * 找回密码
     */
    findPassword(params) {
        return this.commonApi(`evo-visitor/VERSION/card/person/resetPassword?systime=${new Date().getTime()}`, 'post', params)
    },
    /**
     * 获取验证码
     */
    getValidCode(_phoneNum) {
        return this.commonApi(`evo-visitor/VERSION/card/person/fetchValidCode/${_phoneNum}?systime=${new Date().getTime()}`, 'post', {})
    },
    /**
     * 校验用户是否更改过密码
     */
    pswIsChanged(params) {
        return this.commonApi(`evo-visitor/VERSION/card/person/check/login?userName=${params}`, 'get')
    },
    // /**
    //  * 获取访客列表
    //  */
    // getReviewList(params) {
    //     return this.commonApi(`evo-visitor/VERSION/card/visitor/getReviewList?systime=${new Date().getTime()}`, 'post', params)
    // },
    /**
     * 获取访客列表
     */
    getReviewList(params) {
        return this.commonApi(`evo-visitor/VERSION/custom/visitor/getReviewList?systime=${new Date().getTime()}`, 'post', params)
    },
    getVisitorList(params) {
        return this.commonApi(`evo-visitor/VERSION/custom/visitor/getVisitorList?systime=${new Date().getTime()}`, 'post', params)
    },
    /**
     * 获取预约详情
     */
    getVisitorInfoById(params) {
        return this.commonApi(`evo-visitor/VERSION/card/visitor/getReviewInfoByVisitorId/${params.id}?isv_id=${params.isv_id || ''}&v_timeStr=${params.v_timeStr || ''}&systime=${new Date().getTime()}`, 'get', {})
    },
    /**
     * 获取预约详情
     */
    getVisitorInfoById1(params) {
        return this.commonApi(`evo-visitor/VERSION/card/visitor/getReviewInfoByVisitorId/${params.id}?v_timeStr=${params.v_timeStr || ''}&systime=${new Date().getTime()}`, 'get', {})
    },
    /**
     * 获取预约详情
     */
    getVisitorInfo(params) {
        return this.commonApi(`evo-visitor/VERSION/custom/visitor/getReviewInfo
        `, 'post', params)
    },

    /**
     * 审批
     */
    review(params) {
        return this.commonApi(`evo-visitor/VERSION/card/visitor/review?systime=${new Date().getTime()}`, 'post', params)
    },
    /**
     * 批量审批
     */
    batchReview(params) {
        return this.commonApi(`evo-visitor/VERSION/card/visitor/reviewBatch?systime=${new Date().getTime()}`, 'post', params)
        // return new Promise((resolve, reject) => {
        //     vue.resetAjax({
        //         method: "post",
        //         isNoLock: true,
        //         isENoTip: true,
        //         isSNoTip: true,
        //         data: params,
        //         // headers: {
        //         //     Authorization: `bearer 4152:9maZzfq7Ohw0H3e8krvvMpfTOBdRSAZA`
        //         // },
        //         url: `evo-visitor/VERSION/card/visitor/reviewBatch`,
        //         onSuccess(res) {
        //             resolve(res.data);
        //         },
        //         onError(res) {
        //             reject(res);
        //         }
        //     });
        // });
    },
    /**
     * 我的预约
     */
    myAppointmentInfo(params) {
        return this.commonApi(`evo-visitor/VERSION/card/visitor/history/appointmentInfo?phoneNum=${params.phoneNum}&pageNum=1&pageSize=1000&systime=${new Date().getTime()}`, 'post', {})
    },

    /**
     * 检查内外部人员
     */
    checkPerson(params) {
        return this.commonApi(`evo-visitor/VERSION/card/visitor/check-by-phone-and-certificate-number?phoneNum=${params.phoneNum}&certificateNumber=${params.certificateNumber}&systime=${new Date().getTime()}`, 'get', {})
    },
    /**
     * 根据id查询内部人员手机号与姓名
     */
    // checkPersonById(id) {
    //     return this.commonApi(`evo-visitor/VERSION/card/person/getPhoneNum/${id}?systime=${new Date().getTime()}`, 'get', {})
    // },
    checkPersonIdByuserId(id) {
        return this.commonApi(`evo-visitor/VERSION/card/visitor/user/info?userId=${id} `, 'get', {})
    },
    //上传文件
    uploadFacePic(file) {
        return this.commonApi('evo-visitor/VERSION/card/visitor/upload/web/face', 'post', file)
    },
    // 根据身份证号获取用户信息
    getUserInfoByIdCard(paperNumber) {
        // return this.commonApi(`evo-visitor/VERSION/person/subsystem/get-by-paper-number?paperNumber=${paperNumber}`, 'get', {})
        return this.commonApi(`evo-brm/VERSION/person/subsystem/get-by-paper-number?paperNumber=${paperNumber}`, 'get', {})
    },
    // 新增人脸信息
    addPersonInfoApproval(params) {
        return this.commonApi(`evo-brm/VERSION/person-info-approval`, 'post', params)
    },
    // 获取人脸信息
    getPersonInfoApproval(userId) {
        return this.commonApi(`evo-brm/VERSION/person-info-approval/${userId}`, 'get', {})
    },
    // 人脸信息审批
    reviewPersonInfoApproval(params) {
        return this.commonApi(`evo-brm/VERSION/person-info-approval/review`, 'post', params)
    },
    // 获取部门树数据
    getDepartmentTree(data) {
        if (data) {
            return this.commonApi(`evo-brm/VERSION/department/tree?name=&showCascadeNode=1&parentId=${data.parentId}&checkStat=${data.checkStat}`, 'get', {})
        } else {
            return this.commonApi(`evo-brm/VERSION/department/tree?name=&showCascadeNode=1`, 'get', {})
        }
    },
    // 获取微信Openid
    // getOpenId(code) {
    //     return this.commonApi(`weixin/sns/oauth2/access_token?appid=wxfddb0feccc953243&secret=859613b25c368ecdfb809a215cc305cc&code=${code}&grant_type=authorization_code`, 'get', {})
    // },
    // 获取验证码
    getValidateCode(phone) {
        return this.commonApi(`evo-channel/1.0.0/custom/officialAccounts/visitorSystem/verificationCode?phone=${phone}`, 'get', {})
    },
    // 获取验证码
    // getOrgCode(phone) {
    //     return this.commonApi(`evo-erm/VERSION/h5/org/children?code=001&param=&recursive=true&leaf=true&sortType=4&all=true`, 'get', {})
    // },
    // 加密的
    /**
     * 获取组织树
     * @param {string} phone - 手机号（参数未使用）
     * @param {string} visitorstampKey - 时间戳（可选）
     * **/
    getOrgCode(phone, visitorstampKey) {
        const timestamp = visitorstampKey || new Date().getTime() + '000'
        return this.commonApi(
            `evo-visitor/VERSION/card/visitor/h5/org/children?code=001&param=&recursive=true&leaf=true&sortType=4&all=true`,
            'get',
            {},
            {
                'Visitorstamp-Key': timestamp
            }
        )
    },
    // 注册
    register(params) {
        return this.commonApi(`evo-channel/1.0.0/custom/officialAccounts/visitorSystem/register?type=${params.type}&code=${params.code}&state=${params.state}&verificationCode=${params.verificationCode}&phone=${params.phone}`, 'get', {})
    },
    // evo-visitor/1.0.0/card/visitor/config/h5/109
    // 注册
    getTab(params) {
        return this.commonApi(`evo-visitor/VERSION/card/visitor/config/h5/109`, 'get', {})
    },
    // getVisitorPerson(params) {
    //     return this.commonApi(`evo-erm/VERSION/h5/person/page?pageSize=10000&pageNum=1&total=4074&personType=&param=&orgCode=${params}&captureType=&idCaptureType=&sex=&filterPermissions=false`, 'get', {})
    // },
    // 加密的
    /**
     * 获取访客人员列表
     * @param {string} params - 组织编码
     * @param {string} visitorstampKey - 时间戳（可选）
     * **/
    getVisitorPerson(params, visitorstampKey) {
        const timestamp = visitorstampKey || new Date().getTime() + '000'
        return this.commonApi(
            `evo-visitor/VERSION/card/visitor/h5/person/page?pageSize=10000&pageNum=1&total=4074&personType=&param=&orgCode=${params}&captureType=&idCaptureType=&sex=&filterPermissions=false`,
            'get',
            {},
            {
                'Visitorstamp-Key': timestamp
            }
        )
    },
    // 跳转三方登录接口
    toThirdLogin(params) {
        return this.commonApi(`evo-channel/VERSION/custom/officialAccounts/visitorSystem/login?code=${params.code}&state=${params.state}&type=${params.type}`, 'get', {})
    },
    // 获取“便捷邀约模式”开关状态
    getVisitConfig(parma) {
        return new Promise((resolve, reject) => {
            vue.resetAjax({
                method: 'get',
                url: `evo-visitor/VERSION/card/visitor/config/` + parma,
                isNoLock: true,
                isENoTip: true,
                isSNoTip: true,
                onSuccess(rel) {
                    resolve(rel.data)
                },
                onError(rel) {
                    reject(rel)
                }
            })

        })
    },
     // 根据访客类型获取车辆权限
    getCarAuthority(visitorTypeId) {
        return new Promise((resolve, reject) => {
            vue.resetAjax({
                method: "get",
                isNoLock: true,
                isENoTip: true,
                isSNoTip: true,
                url: `evo-visitor/VERSION/visitor-type/visitor-carPermissions/${visitorTypeId}`,
                onSuccess(res) {
                    resolve(res.data);
                },
                onError(res) {
                    reject(res);
                }
            });
        });
    },
    // 获取审批统计数据
    getApprovePersonNum(personCode) {
        return new Promise((resolve, reject) => {
            vue.resetAjax({
                method: "get",
                isNoLock: true,
                isENoTip: true,
                isSNoTip: true,
                url: `evo-visitor/VERSION/custom/visitor/todayReviewStc?personCode=${personCode}`,
                onSuccess(res) {
                    resolve(res.data);
                },
                onError(res) {
                    reject(res);
                }
            });
        });
    },
    // 获取访客手机号
    getOpenIdPhone(params) {
        return new Promise((resolve, reject) => {
            // resolve({
            //     "success": true,
            //     "code": "0",
            //     "errMsg": "请求成功",
            //     "data": {
            //         "openId": "ceshiopenId1",
            //         "phone": "14444444444"
            //     }
            // })
            vue.resetAjax({
                method: "get",
                isNoLock: true,
                isENoTip: true,
                isSNoTip: true,
                url: `evo-channel/1.0.0/custom/officialAccounts/getOpenidByCode?code=${params.code || ''}&state=${params.state || ''}`,
                onSuccess(res) {
                    resolve(res.data);
                },
                onError(res) {
                    reject(res);
                }
            });
        });
    },
    // 解除绑定
    freeBindApi(params) {
        return new Promise((resolve, reject) => {
            vue.resetAjax({
                method: "post",
                isNoLock: true,
                isENoTip: true,
                isSNoTip: true,
                data: params,
                url: `evo-channel/1.0.0/custom/officialAccounts/delBindRel`,
                onSuccess(res) {
                    resolve(res.data);
                },
                onError(res) {
                    reject(res);
                }
            });
        });
    },
    // 绑定手机号
    bindPhoneApi(params) {
        return new Promise((resolve, reject) => {
            vue.resetAjax({
                method: "post",
                isNoLock: true,
                isENoTip: true,
                isSNoTip: true,
                data: params,
                url: `evo-channel/1.0.0/custom/officialAccounts/saveBindRel`,
                onSuccess(res) {
                    resolve(res.data);
                },
                onError(res) {
                    reject(res);
                }
            });
        });
    },
    // 获取key
    getKeyApi() {
        return new Promise((resolve, reject) => {
            // 需要干掉
            // resolve({
            //     "success": true,
            //     "code": "0",
            //     "errMsg": "请求成功",
            //     "data": "==AMwADMwADMwcDN5UzM3ADN6olM210cwdmcZNXW0kVI6FTbR92VXdFSBRHWtZUUtYnN"
            // })
            // 获取密钥接口
            let timestamp = new Date().getTime() + '000'
            vue.resetAjax({
                method: "get",
                isNoLock: true,
                isENoTip: true,
                isSNoTip: true,
                headers: {
                    'Visitorstamp-Key': timestamp
                },
                url: `evo-visitor/VERSION/card/visitor/visitorDataKey`,
                onSuccess(res) {
                    // 将时间戳一并返回
                    resolve({
                        data: res.data,
                        visitorstampKey: timestamp
                    });
                },
                onError(res) {
                    reject(res);
                }
            });
        });
    },
}
export default api
